/*=========================================================================================
	File Name: moduleAuthActions.js
	Description: Auth Module Actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import userJson from "../../../public/user.json";
import axios from "axios";
import router from '../../router'
import state from "../state"
import store from "../store";

export default {
	listCustomerinfoForRole({ getters, commit, dispatch }, item) {
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
				dispatch("listCustomerInfoForCustomer", item).then(response => {
					resolve(response);
				})
			}
			else if (state.AppActiveUser.ROLE == "Company") dispatch("listCustomerInfoForCustomer", state.AppActiveUser.companyid).then(response => {
				resolve(response);
			})
		})
	},
	//set-up company start
	updateCustomer({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.put(sistemAddress + "api/uzumservice/Company/update/company", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						commit("DELETE_ITEM_COMPANY", item.companyId)
						commit("ADD_ITEM_COMPANY", item)
						resolve(response);
					})
					.catch(err => {
						resolve(err.response);
					});
		});
	},
	addCustomer({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.post(sistemAddress + "api/uzumservice/Company/add/company", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						commit("ADD_ITEM_COMPANY", item)
						resolve(response);
					})
					.catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						}
						resolve(err.response);
					});
		});
	},
	listCustomer({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
						axios.get(sistemAddress + "api/uzumservice/Company/list/company", {
							headers: {
								Authorization: `Bearer ${token}`,
								token: token
							}
						}).then(response => {
							if (response.status == 200) {
								item = JSON.parse(response.data.json);
								commit("CUSTOMER_LIST", item);
								resolve(response.data);
							} else if (response.status == 401) {
								router.push("/login")
							}
						}).catch(err => {
							if (err.response.status == 401) {
								router.push("/login")
							} else if (err.response.status == 400) {
								commit("CUSTOMER_LIST", []);
							}
							resolve(err.response);
						});
					}
				});
			} catch (error) {

			}

	},
	deleteCustomer({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.delete(sistemAddress + "api/uzumservice/Company/delete/company/" + item, {
						headers: {
							Authorization: `Bearer ${token}`
						}
					})
					.then(response => {
						commit("DELETE_ITEM_COMPANY", item)
						resolve(response);
					})
					.catch(err => {

						resolve(err.response);
					});
		});
	},
	//set-up company end
	//set-up company action start
	addCustomerAct({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.post(sistemAddress + "api/uzumservice/Company/add/companytrans", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {
						resolve(err.response);
					});
		});
	},
	deleteCustomerAct({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Company/delete/companytrans/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {

					resolve(err.response);
				});
		});
	},
	updateCustomerAct({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {

			axios
				.put(sistemAddress + "api/uzumservice/Company/update/companytrans", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listPaymentType({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.get(sistemAddress + "api/uzumservice/Company/peymenttypelist", {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = response.data;
							commit("PAYMENT_LIST", item);
							resolve(response);
						} else if (response == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							commit("PAYMENT_LIST", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	listCustomerActForCompany({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.get(sistemAddress + "api/uzumservice/Company/list/companytrasn/" + item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = JSON.parse(response.data.json);
							commit("CUSTOMERACT_LIST", item);
							resolve(response.data);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							commit("CUSTOMERACT_LIST", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	listCustomerAct({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
						axios.get(sistemAddress + "api/uzumservice/Company/list/companytrans", {
							headers: {
								Authorization: `Bearer ${token}`,
								token: token
							}
						}).then(response => {
							if (response.status == 200) {
								item = JSON.parse(response.data.json);
								commit("CUSTOMERACT_ALL_LIST", item);
								resolve(response.data);
							} else if (response.status == 401) {
								router.push("/login")
							}
						}).catch(err => {
							console.log(err)
							if (err.response.status == 401) {
								router.push("/login")
							} else if (err.response.status == 400) {
								commit("CUSTOMERACT_ALL_LIST", []);
							}
							resolve(err.response);
						});
					}
				});
			} catch (error) {

			}

	},
	listCustomerActBalance({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
						axios.get(sistemAddress + "api/uzumservice/Company/list/companytransbalance/" + item, {
							headers: {
								Authorization: `Bearer ${token}`,
								token: token
							}
						}).then(response => {
							if (response.status == 200) {
								item = JSON.parse(response.data.json);
								commit("CUSTOMERACT_BALANCE", item);
								resolve(response.data);
							} else if (response.status == 401) {
								router.push("/login")
							}
						}).catch(err => {
							if (err.response.status == 401) {
								router.push("/login")
							} else if (err.response.status == 400) {
								commit("CUSTOMERACT_BALANCE", []);
							}
							resolve(err.response);
						});
					}
				});
			} catch (error) {

			}

	},
	//set-up company action end
	//set-up company supplier start
	addCustomerSupplier({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.post(sistemAddress + "api/uzumservice/Stock/add/supplier", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {
						resolve(err.response);
					});
		});
	},
	deleteCustomerSupplier({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Stock/delete/supplier/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {

					resolve(err.response);
				});
		});
	},
	updateCustomerSupplier({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {

			axios
				.put(sistemAddress + "api/uzumservice/Stock/update/supplier", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listCustomerSupplier({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
						axios.get(sistemAddress + "api/uzumservice/Stock/list/supplier", {
							headers: {
								Authorization: `Bearer ${token}`,
								token: token
							}
						}).then(response => { 
							if (response.status == 200) {
								item = JSON.parse(response.data.json); 
								commit("SUPPLIER_ALL_LIST", item);
								resolve(response.data);
							} else if (response.status == 401) {
								router.push("/login")
							}
						}).catch(err => {
							console.log(err)
							if (err.response.status == 401) {
								router.push("/login")
							} else if (err.response.status == 400) {
								commit("SUPPLIER_ALL_LIST", []);
							}
							resolve(err.response);
						});
					}
				});
			} catch (error) {

			}

	},
	//set-up company supplier end

	// set-up compnay info start
	updateCustomerInfo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.put(sistemAddress + "api/uzumservice/Company/update/companyinfo", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {
						resolve(err.response);
					});
		});
	},
	deleteCustomerInfo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.delete(sistemAddress + "api/uzumservice/Company/delete/companyinfo/" + item, {
						headers: {
							Authorization: `Bearer ${token}`
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {

						resolve(err.response);
					});
		});
	},
	addCustomerInfo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.post(sistemAddress + "api/uzumservice/Company/add/companyinfo", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {
						resolve(err.response);
					});
		});
	},
	listCustomerInfo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios.get(sistemAddress + "api/uzumservice/Company/list/companyinfo", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				}).then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("CUSTOMER_INFO_ALL_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login")
					}
				}).catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});;
		});
	},
	listCustomerInfoForCustomer({ commit }, item) {

		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Company/list/companyinfo/company/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("CUSTOMER_INFO_LIST_FOR_CUSTOMER", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	// set-up compnay info end

	// set-up compnay employee start
	addEmployee({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.post(sistemAddress + "api/uzumservice/Company/add/employee", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {

						resolve(err.response);
					});
		});
	},
	listEmployeeForCompany({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios.get(sistemAddress + "api/uzumservice/Company/list/employee/company/" + item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				}).then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("EMPLOYEE_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login")
					}
				}).catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});;
		});
	},
	listEmployee({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios.get(sistemAddress + "api/uzumservice/Company/list/employee/", {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				}).then(response => {
					if (response.status == 200) {
						item = JSON.parse(response.data.json);
						commit("EMPLOYEE_ALL_LIST", item);
						resolve(response.data);
					} else if (response.status == 401) {
						router.push("/login")
					}
				}).catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});;
		});
	},
	updateEmployee({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.put(sistemAddress + "api/uzumservice/Company/update/employee", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {
						resolve(err.response);
					});
		});
	},
	deleteEmployee({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin")
				axios
					.delete(sistemAddress + "api/uzumservice/Company/delete/employee/" + item, {
						headers: {
							Authorization: `Bearer ${token}`
						}
					})
					.then(response => {
						resolve(response);
					})
					.catch(err => {

						resolve(err.response);
					});
		});
	},
	// set-up compnay employee end

}
